import { render } from "../views/consent_modal.html?vue&type=template&id=2cb352d6&ts=true&external"
import script from "../scripts/consent_modal.ts?vue&type=script&lang=ts&external"
export * from "../scripts/consent_modal.ts?vue&type=script&lang=ts&external"

import "../css_builds/components/modal.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"ClientApp/components/consent_modal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2cb352d6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2cb352d6', __exports__)) {
    api.reload('2cb352d6', __exports__)
  }
  
  module.hot.accept("../views/consent_modal.html?vue&type=template&id=2cb352d6&ts=true&external", () => {
    api.rerender('2cb352d6', render)
  })

}


export default __exports__